import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { useLang } from "../context/LangContext";
import { useStore } from "../context/StoreContext";
import { ProductCard } from "../components/store/ProductCard";
import { Reveal } from "../components/store/Reveal";
import { Skeleton } from "../components/ui/skeleton";

const TITLES = { all: "nav_all", new: "nav_new", offers: "nav_offers", bestsellers: "bestsellers", featured: "featured" };
const SORTS = ["newest", "bestselling", "price_asc", "price_desc"];
const SORT_KEYS = { newest: "sort_newest", bestselling: "sort_best", price_asc: "sort_price_asc", price_desc: "sort_price_desc" };

export default function Shop() {
  const { collection = "all" } = useParams();
  const { t, L } = useLang();
  const { categories } = useStore();
  const [sort, setSort] = useState("newest");
  const [items, setItems] = useState(null);

  useEffect(() => {
    setItems(null);
    api.get("/products", { params: { collection, sort } }).then((r) => setItems(r.data));
  }, [collection, sort]);

  const cat = categories.find((c) => c.slug === collection);
  const title = cat ? L(cat, "name") : t(TITLES[collection] || "nav_all");

  return (
    <div data-testid="shop-page" className="container-q pb-28 pt-14 sm:pt-20">
      <div className="mb-12 flex flex-col justify-between gap-6 border-b border-sand pb-8 sm:flex-row sm:items-end">
        <div>
          <p className="eyebrow mb-3">{t("collection")}</p>
          <h1 data-testid="shop-title" className="text-4xl sm:text-5xl lg:text-6xl">{title}</h1>
          {items && <p className="mt-3 text-sm text-sand-dark">{t("items_count", { n: items.length })}</p>}
        </div>
        <div className="no-scrollbar flex gap-5 overflow-x-auto">
          {SORTS.map((s) => (
            <button key={s} data-testid={`sort-${s}`} onClick={() => setSort(s)}
              className={`shrink-0 pb-1 text-[13px] transition-colors ${sort === s ? "border-b border-ink" : "text-sand-dark hover:text-ink"}`}>
              {t(SORT_KEYS[s])}
            </button>
          ))}
        </div>
      </div>
      {!items ? (
        <div className="grid grid-cols-2 gap-5 sm:gap-8 lg:grid-cols-4">
          {[...Array(8)].map((_, i) => <Skeleton key={i} className="aspect-[3/4] rounded-none bg-sand-light" />)}
        </div>
      ) : items.length === 0 ? (
        <p data-testid="shop-empty" className="py-24 text-center font-display text-2xl">{t("no_results")}</p>
      ) : (
        <div className="grid grid-cols-2 gap-x-5 gap-y-12 sm:gap-x-8 sm:gap-y-16 lg:grid-cols-4">
          {items.map((p, i) => (
            <Reveal key={p.id} delay={(i % 4) * 0.06}><ProductCard p={p} /></Reveal>
          ))}
        </div>
      )}
    </div>
  );
}
